import React from 'react';
import { faDiscord, faTwitch } from '@fortawesome/free-brands-svg-icons';
import {
  faBars,
  faRotate,
  faArrowRightToBracket
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  ToggleGameSwitcher,
  ToggleMenu,
  ToggleSideBar
} from '../actions/Layout.actions';
import { Logo } from '../../common/components/logo';
import { RootState } from '../../../state/Store';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
// import { UserMiniature } from './user-miniature';

interface IProps {
  game: string;
}

export const DashboardTopNav: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();

  const model = useSelector((state: RootState) => ({
    isSideMenuExtended: state.layout.isSideMenuExtended
  }));

  return (
    <div className="top-nav">
      <div className="inside">
        <Button
          variant="link"
          className="left-menu-control desktop"
          onClick={() => dispatch(ToggleSideBar())}
        >
          <FontAwesomeIcon
            icon={faArrowRightToBracket}
            width="24"
            className={`${model.isSideMenuExtended ? 'fa-rotate-180' : ''}`}
          />
        </Button>
        {/* {props.game === 'hsr' && (
          <div className="special-ad">
            <div className="inner">
              <p>Play AFK Journey Now!</p>
              <Button>Try now!</Button>
            </div>
          </div>
        )} */}
        {/* {props.game === 'hsr' && (
          <p className="hsr-desktop-info">
            <FontAwesomeIcon icon={faCircleExclamation} width="24" /> Check
            Robin's early impressions{' '}
            <Link to="/star-rail/guides/early-impressions-robin">here</Link>!
          </p>
        )} */}
        <Button
          variant="link"
          className="left-menu-control mobile"
          onClick={() => dispatch(ToggleMenu())}
        >
          <FontAwesomeIcon icon={faBars} width="24" />
        </Button>
        <Button
          variant="link"
          className="game-switcher-control mobile"
          onClick={() => dispatch(ToggleGameSwitcher())}
        >
          <FontAwesomeIcon icon={faRotate} width="24" />
        </Button>
        <div className="logo">
          <Logo size="minimal" />
        </div>
        <div className="left-links">
          {props.game === 'nikke' && (
            <Link to="/nikke/watch-our-partners">
              <Button variant="primary" className="discord-no-login purple">
                <FontAwesomeIcon icon={faTwitch} width="24" />{' '}
                <span>Our Partners</span>
              </Button>
            </Link>
          )}
          <Button
            href="https://discord.gg/prydwen"
            variant="primary"
            className="discord-no-login"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faDiscord} width="24" />{' '}
            <span>Our Discord</span>
          </Button>
          <Button
            href="https://ko-fi.com/antillar"
            variant="primary"
            className="discord-no-login red ko-fi"
            target="_blank"
            rel="noreferrer"
          >
            <StaticImage src="../../../images/kofi.webp" alt="Ko-Fi" />
            <span>Buy us a Ko-Fi</span>
          </Button>
        </div>
        {/* <UserMiniature /> */}
      </div>
    </div>
  );
};
